import { Token } from '@ui/models/token/model';
import { Fraction } from 'bi-fraction';

import type { TokenFetcher } from '../model';

export const stableFetcher: TokenFetcher<
  Token.USDC | Token.USDT | Token.DAI | Token.vUSD
> = {
  support: (token): token is Token.USDC | Token.USDT | Token.DAI | Token.vUSD =>
    token === Token.USDC ||
    token === Token.USDT ||
    token === Token.DAI ||
    token === Token.vUSD,
  fetch: () => {
    return {
      usd_price: Fraction.ONE,
      usd_price_change_24h: Fraction.ZERO,
    };
  },
};
